export default __webpack_public_path__ + "static/media/BLM.cc00858d.svg";